import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaComment } from 'react-icons/fa';

const ObservationUI = ({
  questionId,
  answerObservations,
  setAnswerObservations,
  handleInputChange,
  MySwal,
  isSimulation = false,
  readOnly = false
}) => {
  const { t } = useTranslation();
  const hasObservation = answerObservations[questionId];
  
  // Function to handle observation input
  const handleObservationInput = (questionId, observation) => {
    if (readOnly) return; // Prevent changes in read-only mode
    
    setAnswerObservations(prev => ({
      ...prev,
      [questionId]: observation
    }));
  };
  
  if (hasObservation) {
    return (
      <div className="mt-3 mb-0">
        <div className="card">
          <div className="card-body p-3">
            <div className="d-flex align-items-center">
              <FaComment className="me-2" size={18} color="#6c757d" />
              <div className="flex-grow-1">
                <h6 className="mb-0">{t('providedObservation', { ns: 'labels' })}</h6>
                <p className="mb-0 text-break">{answerObservations[questionId]}</p>
              </div>
              {!readOnly && (
                <button 
                  type="button" 
                  className="btn btn-sm btn-outline-danger ms-2"
                  onClick={() => {
                    // Remove observation
                    setAnswerObservations(prev => {
                      const newObservations = {...prev};
                      delete newObservations[questionId];
                      return newObservations;
                    });
                  }}
                >
                  <i className="fa fa-times"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  // Don't show the input form in read-only mode if there's no observation
  if (readOnly) {
    return null;
  }
  
  return (
    <div className="mt-3 mb-0">
      <div className="input-group">
        <span className="input-group-text">
          <FaComment />
        </span>
        <textarea 
          className="form-control" 
          placeholder={t('enterObservation', { ns: 'labels' })}
          id={`observation-input-${questionId}`}
          rows="3"
          disabled={readOnly}
        ></textarea>
      </div>
      <div className="d-flex justify-content-end mt-2">
        <button 
          className="btn btn-outline-primary btn-sm"
          type="button"
          disabled={readOnly}
          onClick={() => {
            if (readOnly) return; // Extra safety check
            
            const observationInput = document.getElementById(`observation-input-${questionId}`);
            const observation = observationInput.value.trim();
            
            if (observation) {
              handleObservationInput(questionId, observation);
              
              // Show success message
              MySwal.fire({
                title: t('observationAdded', { ns: 'labels' }),
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
              });
            }
          }}
        >
          {t('save', { ns: 'labels' })}
        </button>
      </div>
    </div>
  );
};

export default ObservationUI; 